
import {
  Action,
} from 'one-state';

import {
  SET,
  REINIT,
} from './types';
import {
  AlertsModal
} from '../../one-card-alerts/src/model';

/**
* Redux action creator to set the list
* of Active  Problems
* @param activeproblem array of ActiveProblem
* @returns action instance
*/
export const setAction = (alert: AlertsModal):
  Action<typeof SET, AlertsModal> => ({
      type: SET,
      payload: alert,
  });
/**
* Re-initialize the state
* @returns action instance
*/
export const resetAction = ():
  Action<typeof REINIT> => ({
      type: REINIT,
  });

/**
* List of all valid actions
*/
export type Actions =
  ReturnType<typeof setAction> |
  ReturnType<typeof resetAction>;